import * as React from 'react';
import * as author from "./style.module.scss";
export const Author = () => {
  return (
    <section className={author.author}>
      <div className="container">
        <div className={author.container}>
          <div className={author.left}>
            <h2>Автор курса:</h2>
            <h3>Николай Ягодкин –</h3>
            <p>самый известный в России специалист по технологиям обучения и изучению языков</p>
            <ul>
              <li>
                Получил 2 высших образования: математическое и педагогическое,
                специалист по инновационным методикам обучения
              </li>
              <li>
                Основатель и владелец образовательного центра Advance, полные
                программы которой прошли более 50&nbsp;000 человек по всему миру
              </li>
              <li>
                Отзывов о результатах применения его технологий только ВКонтакте
                больше 22&nbsp;000
              </li>
              <li>
                Репортажи о его технологиях и результатах их применения
                показывали по Первому каналу, НТВ и&nbsp;т.д.
              </li>
              <li>
                Консультирует министров образования и обучает парламенты
                зарубежных стран
              </li>
              <li>
                Среди частных учеников: министры, депутаты, ректоры и профессора,
                президенты, председатели и члены правлений крупнейших компаний
                и банков и их дети
              </li>
            </ul>
          </div>
          <div className={author.right}>
            <blockquote>
              «Самый эффективный способ изучения
              языка - интенсивный. Чем меньше срок,
              тем выше эффективность на единицу
              времени просто потому, что человек
              не успевает забыть, а забываем мы
              более 90% того, что мы учим»
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};
